import { type Theme } from '@prisma/client'
import History from '@tiptap/extension-history'
import { type Dispatch } from 'react'
import { type tabs } from '#app/components/ui/customizer-bar/editor-bar-email.js'
import { type CustomizerData } from '#app/utils/customizer.client.js'
import API from '../lib/api'
import {
	CharacterCount,
	Color,
	Document,
	Dropcursor,
	FileHandler,
	Focus,
	CryptoWalletInput,
	FontFamily,
	FontSize,
	Heading,
	Highlight,
	ImageBlock,
	Link,
	DropdownInput,
	Placeholder,
	Selection,
	StarterKit,
	Subscript,
	Superscript,
	TextAlign,
	TextStyle,
	Typography,
	Underline,
	ImageUpload,
	SimpleForm,
	AdvancedForm,
	LinkButton,
	Variable,
	Input,
	InputSingleSelect,
	FrameBlock,
	Divider,
	NoNewLine,
	Paragraph,
	LinkIcon,
	SocialIcons,
	ReferralBlock,
	Block,
	Columns,
	Column,
	Spacer,
	ShortAnswer,
	SubmitButton,
	LongAnswer,
	EmailInput,
	CheckboxesInput,
	NumberInput,
	LinkInput,
	ShareButtons,
} from '.'
interface ExtensionKitProps {
	userId?: string
	userName?: string
	userColor?: string
	theme?: Theme
	editable: boolean
	data?: CustomizerData
	vars?: {
		sub?: boolean
		list?: boolean
		user?: boolean
	}
	setTab?: Dispatch<React.SetStateAction<tabs>>
}

export const ExtensionKit = ({
	editable,
	data,
	vars = { sub: false, list: true, user: false },
	setTab,
}: ExtensionKitProps) => [
	Block,
	Columns,
	Column.configure({ setTab }),
	Spacer,
	ReferralBlock.configure({
		...(data?.sub?.referralLink && { referralLink: data.sub.referralLink }),
		...(data?.sub?.position && { position: data.sub.position }),
		...(data?.sub?.jumpOne && { jumpOne: data.sub.jumpOne }),
	}),
	ShareButtons.configure({
		...(data?.sub?.referralLink && { referralLink: data.sub.referralLink }),
	}),
	Variable.configure({
		...(data && { data }),
		vars,
	}),

	Heading.configure({
		levels: [1, 2, 3, 4, 5, 6],
		HTMLAttributes: {},
	}),
	Paragraph.configure({
		HTMLAttributes: {
			style: editable
				? 'line-height: 1.7em;'
				: 'margin-bottom: 24px; line-height: 1.7em;',
		},
	}),
	LinkButton.configure({
		data: {
			theme: data?.theme,
			...(data?.sub && { sub: data.sub }),
			...(data?.list && { list: data.list }),
		},
	}),
	CryptoWalletInput,
	NoNewLine,
	FrameBlock,
	LinkIcon,
	SocialIcons,
	SimpleForm,
	EmailInput,
	AdvancedForm,
	Divider,
	Input,
	NumberInput,
	LinkInput,
	ShortAnswer,
	CheckboxesInput,
	LongAnswer,
	SubmitButton,
	DropdownInput,
	InputSingleSelect,
	Document,
	History.configure({
		depth: 100,
	}),
	Selection,
	StarterKit.configure({
		document: false,
		paragraph: false,
		dropcursor: false,
		heading: false,
		horizontalRule: false,
		blockquote: false,
		history: false,
		codeBlock: false,
	}),
	TextStyle,
	FontSize,
	FontFamily,
	Color,
	Link.configure({
		openOnClick: false,
	}),
	Highlight.configure({ multicolor: true }),
	Underline,
	CharacterCount.configure({ limit: 50000 }),
	ImageUpload.configure({}),
	ImageBlock,
	FileHandler.configure({
		allowedMimeTypes: ['image/png', 'image/jpeg', 'image/gif', 'image/webp'],
		onDrop: (currentEditor, files, pos) => {
			files.forEach(async file => {
				const url = await API.uploadImage(file)

				currentEditor.chain().setImageBlockAt({ pos, src: url }).focus().run()
			})
		},
		onPaste: (currentEditor, files) => {
			files.forEach(async file => {
				const url = await API.uploadImage(file)

				return currentEditor
					.chain()
					.setImageBlockAt({
						pos: currentEditor.state.selection.anchor,
						src: url,
					})
					.focus()
					.run()
			})
		},
	}),
	TextAlign.extend({
		addKeyboardShortcuts() {
			return {}
		},
	}).configure({
		types: ['heading', 'paragraph'],
	}),
	Subscript,
	Superscript,
	Typography,
	Placeholder.configure({
		includeChildren: true,
		showOnlyCurrent: false,
		placeholder: () => '',
	}),
	Focus,
	Dropcursor.configure({
		width: 2,
		class: 'ProseMirror-dropcursor border-black',
	}),
]

export default ExtensionKit
